<form [formGroup]="form" (ngSubmit)="login()">
	<div class="form-floating mb-3">
		<input
			type="text"
			class="form-control"
			id="username"
			[placeholder]="'LOGIN.LABEL.TITLE' | translate"
			formControlName="username"
			data-testid="login-input"
			[readonly]="isLoadingBtnLogin"
		/>
		<label for="username" class="form-label">{{
			"LOGIN.LABEL.TITLE" | translate
		}}</label>
		<app-validation-errors
			[abstractControl]="this.form.get('username')"
		></app-validation-errors>
	</div>

	<div class="form-floating mb-3">
		<input
			type="password"
			class="form-control"
			id="password"
			[placeholder]="'LOGIN.LABEL.PASSWORD' | translate"
			formControlName="password"
			data-testid="password-input"
			[readonly]="isLoadingBtnLogin"
		/>
		<label for="password" class="form-label">{{
			"LOGIN.LABEL.PASSWORD" | translate
		}}</label>
		<app-validation-errors
			[abstractControl]="this.form.get('password')"
		></app-validation-errors>
	</div>

	<button
		type="submit"
		class="btn btn-primary submit-button"
		data-testid="login-submit"
		[disabled]="form.invalid || isLoadingBtnLogin"
	>
		<ng-container *ngIf="isLoadingBtnLogin">
			<span
				class="spinner-border spinner-border-sm me-2"
				role="status"
			></span>
		</ng-container>

		{{ "LOGIN.LABEL.SUBMIT" | translate }}
	</button>
</form>
